import { graphql } from '@/gql';
import type { FetchAbTestsQuery, PaginationInputType } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import util from '@/Utils/util';

export type AbTest = Extract<FetchAbTestsQuery['abTests']['rows'][number], {}>;
export type AbTestGroup = Extract<AbTest['abTestGroups'], {}>[number];

type Vars = {
  pagination?: PaginationInputType | null;
  status?: string | null;
  text?: string | null;
};
export const fetchAbTests = async (variables: Vars) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables,
    query: graphql(`
      query fetchAbTests($pagination: PaginationInputType, $status: String, $text: String) {
        abTests(pagination: $pagination, status: $status, text: $text) {
          __typename
          count
          rows {
            id
            name
            type
            description
            status
            startDate
            endDate
            deactivateDate
            createdAt
            updatedAt
            delay
            endAfterNumUsers
            successConditions
            data
            exclusiveKeys
            abTestGroups {
              createdAt
              data
              description
              groupLabel
              groupType
              groupTarget
              associatedObjectType
              associatedObjectId
              winner
              isActiveForAssignment
              id
              updatedAt
            }
          }
        }
      }
    `),
  });

  if (response.errors?.length) {
    throw new Error(util.getGraphqlError({ graphQLErrors: response.errors }, false), { cause: response });
  }

  return response.data.abTests;
};
